<template>
    <div class="text-center" style="width: 100%;">
        <v-dialog v-model="dialog" id="pred-modal" width="550" @input="onOpen()" scrollable>

            <template v-slot:activator="{ on, attrs }">
                <v-btn :class="{'smaller-text': $vuetify.breakpoint.lg}" style="width: 100%;" color="secondary" :outlined="edit" dark v-bind="attrs" v-on="on" v-if="size === 'block'">{{ label }}</v-btn>
                <v-btn class="mx-2" fab dark x-small color="secondary" v-bind="attrs" v-on="on" v-else>
                    <v-icon dark>mdi-pencil</v-icon>
                </v-btn>
            </template>

            <v-card>
                <v-card-title class="headline pb-4">
                    <span>{{ game.home_team + ' ' + showHomeGoals + ' - ' + showAwayGoals + ' ' + game.away_team }}</span>
                </v-card-title>

                <v-row class="mx-0 px-3 grey lighten-2">
                    <v-col class="py-1 py-sm-3" cols="12" sm="4">
                        Result points: {{ resultPoints }}
                    </v-col>
                    <v-col class="py-1 py-sm-3" cols="12" sm="4">
                        Score points: {{ scorePoints }}
                    </v-col>
                    <v-col class="py-1 py-sm-3" cols="12" sm="4">
                        Total (all games): {{ weekTotalPoints }}
                    </v-col>
                </v-row>

                <v-divider></v-divider>


                <v-row class="pred-form-col-headers-row mx-0 px-3">
                    <v-col class="text-center" cols="3">Home Goals</v-col>
                    <v-col class="text-center" cols="3">Away Goals</v-col>
                    <v-col class="text-center" cols="3">Result Points</v-col>
                    <v-col class="text-center" cols="3">Score Points</v-col>
                </v-row>

                <v-card-text class="pred-form-scroll-section">

                    <table>
                        <tr v-for="i in 16" :key="i">
                            <td class="py-2 text-center" :class="{ active: i - 1 === homeGoals }" @click="updateHome">{{ i - 1 }}</td>
                            <td class="py-2 text-center" :class="{ active: i - 1 === awayGoals }" @click="updateAway">{{ i - 1 }}</td>
                            <td class="py-2 text-center" :class="{ active: i - 1 === resultPoints || (i === 1 && + resultPoints === 10) }" @click="updateResult">{{ i === 1 ? 10 : (i < 12 ? i - 1 : '') }}</td>
                            <td class="py-2 text-center" :class="{ active: i - 1 === scorePoints || (i === 1 && + scorePoints === 10) }" @click="updateScore">{{ i === 1 ? 10 : (i < 12 ? i - 1 : '') }}</td>
                        </tr>
                    </table>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="px-6">
                    <v-alert class="pred-alert too-many-points-alert px-4 py-1" dense outlined block type="error" v-if="showTooManyPointsErr">
                        Week's total points > 50
                    </v-alert>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="dialog = false">Cancel</v-btn>
                    <v-btn color="secondary" :disabled="!canSubmit" @click="submitPrediction">Submit</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
   import axios from 'axios';
   import {mapActions, mapGetters} from "vuex";

  export default {
    name: "predictModal",
    props: ['game', 'size', 'edit'],
    data () {
      return {
        dialog: false,
        homeGoals: null,
        awayGoals: null,
        resultPoints: 1,
        scorePoints: 1,
        thisGP: null,
        goalsArr: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15],
        pointsArr: [1,2,3,4,5,6,7,8,9,10]
      }
    },
    computed: {
      ...mapGetters([
        'weekTotalPoints'
      ]),
      label() {
        return this.edit ? 'Edit' : 'Predict Now';
      },
      hasPredicted() {
        return !!this.game.predictions.length;
      },
      hometeam() {
        return this.$vuetify.breakpoint.name === 'xs' ? this.game.home_abbrv.abbrv : this.game.home_team;
      },
      awayteam() {
        return this.$vuetify.breakpoint.name === 'xs' ? this.game.away_abbrv.abbrv : this.game.away_team;
      },
      showHomeGoals() {
        return this.homeGoals || this.homeGoals === 0 ? this.homeGoals : '?';
      },
      showAwayGoals() {
        return this.awayGoals || this.awayGoals === 0 ? this.awayGoals : '?';
      },
      goals() {
        return this.game.predictions.length ? ' ' + this.game.predictions[0].home_goals + ' - ' + this.game.predictions[0].home_goals + ' ' : ' vs ';
      },
      canSubmit() {
        return (this.homeGoals || this.homeGoals === 0)
                && (this.awayGoals || this.awayGoals === 0)
                && this.resultPoints
                && this.scorePoints
                && !this.tooManyPoints;
      },
      availablePoints() {
        return 50 - (this.weekTotalPoints - this.thisGP);
      },
      tooManyPoints() {
        return this.availablePoints < this.resultPoints + this.scorePoints;
      },
      showTooManyPointsErr() {
        return this.tooManyPoints;
      },
    },
    methods: {
      ...mapActions([
        'getGames',
      ]),
      onOpen() {
        if (this.game.predictions.length) {
          this.homeGoals = this.game.predictions[0].home_goals;
          this.awayGoals = this.game.predictions[0].away_goals;
          this.resultPoints = this.game.predictions[0].result_points;
          this.scorePoints = this.game.predictions[0].score_points;
        } else {
          this.homeGoals = null;
          this.awayGoals = null;
          this.resultPoints = 1;
          this.scorePoints = 1;
        }
        this.thisGamesPoints();
      },
      thisGamesPoints() {
        this.thisGP = this.resultPoints + this.scorePoints;
      },
      updateHome() {
        let pred = event.target.innerText
        this.homeGoals = +pred;
      },
      updateAway() {
        let pred = event.target.innerText
        this.awayGoals = +pred;
      },
      updateResult() {
        let pred = event.target.innerText
        // console.log(pred)
        this.resultPoints = +pred;
      },
      updateScore() {
        let pred = event.target.innerText
        // console.log(pred)
        this.scorePoints = +pred;
      },
      submitPrediction() {
        const data = {
          game_id: this.game.id,
          home_goals: this.homeGoals,
          away_goals: this.awayGoals,
          result_points: this.resultPoints,
          score_points: this.scorePoints
        };

        let url = '';
        let method = '';
        if (this.game.predictions.length) {
          data.id = this.game.predictions[0].id;
          url = process.env.VUE_APP_API_URL + 'prediction/' + data.id;
          method = 'put';
        } else {
          url = process.env.VUE_APP_API_URL + 'prediction';
          method = 'post';
        }

        axios({
          method: method,
          url: url,
          data: data
        })
        .then(response => {
          this.getGames(this.game.week_id);
          this.dialog = false;
        });

      },
    },
  }
</script>

<style lang="scss" scoped>

    .v-dialog {
        height: 200px;
    }
    .headline {
        background: var(--v-secondary-base);
        color: var(--v-primary-base);

        @media (max-width: 600px) {
            color: lime;
            font-size: 1.2rem !important;
        }

    }
    .goals {
        font-size: 1.3rem;
        font-weight: bold;
    }
    .pred-form-scroll-section {
        height: 300px;
    }
    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 1.5rem;

        td {
            border: 1px solid #dddddd;

            &.active {
                background: var(--v-secondary-base);
                color: var(--v-primary-base);
            }
        }
    }
    .pred-alert {
        margin-bottom: 0;
        font-size: 0.8rem;
    }
    .smaller-text {
      font-size: 0.8rem;
    }


</style>
